import goodsList from './goods-list';
import logIn from './login';
import user from './user';
import wallet from './wallet';
import security from './security-center';

function getRouters(...arr) {
  return arr.reduce((prev, curr) => prev.concat(curr), []);
}

export default getRouters(goodsList, logIn, user, wallet, security);
